import { IBaseAction } from '../../../../common/interfaces/IBaseAction'
export enum Keys {
    UPDATETAG = 'react/tags/UPDATETAG',
    LOADTAGS = 'react/tags/LOADTAGS',
    LOADTAGS_FULFILLED = 'react/tags/LOADTAGS_FULFILLED',
    LOADTAGS_REJECTED = 'react/tags/LOADTAGS_REJECTED',
    EDITTAG = 'react/tags/EDITTAG',
    UNDOEDITTAG = 'react/tags/UNDOEDITTAG',
    LOADTAG = 'react/tags/LOADTAG',
    LOADTAG_FULFILLED = 'react/tags/LOADTAG_FULFILLED',
    LOADTAG_REJECTED = 'react/tags/LOADTAG_REJECTED',
    DELETETAG = 'react/tags/DELETETAG',
    DELETETAG_FULFILLED = 'react/tags/DELETETAG_FULFILLED',
    DELETETAG_REJECTED = 'react/tags/DELETETAG_REJECTED',
    SAVETAG = 'react/tags/ADDTAG',
    SAVETAG_FULFILLED = 'react/tags/ADDTAG_FULFILLED',
    SAVETAG_REJECTED = 'react/tags/ADDTAG_REJECTED',
    CLEARSELECTION = 'react/tags/CLEARSELECTION',
    PRINT = "react/tags/PRINT",
    DOWNLOAD = "react/tags/DOWNLOAD",
    OTHER_ACTION = 'react/tags/__any_other_action__',
}

export type Types = IBaseAction<Keys>;